import { Float, ID } from '@adornis/baseql/baseqlTypes.js';
import { registerQuery, registerSubscription } from '@adornis/baseql/metadata/register.js';
import { InspectorOverviewLine } from '@ils/ratings/db/inspectorOverviewLine.js';
import { Slot } from '@ils/slots/db/slot.js';
import {
  getNextSlotForEvaluationResolver,
  getScoreOfSlotResolver,
  getSlotForRatingResolver,
  getSlotsWithoutKonsensResolver,
  subscribeSlotsForEvaluationResolver,
} from '../server/resolver/evaluation.js';

export const getScoreOfSlot = registerQuery({
  operationName: 'getScoreOfSlot',
  type: () => Float,
  resolve: getScoreOfSlotResolver,
  params: [{ name: 'slotID', type: () => String }],
});

export const subscribeSlotsForEvaluation = registerSubscription({
  operationName: 'subscribeSlotsForEvaluation',
  type: () => [Slot],
  resolve: subscribeSlotsForEvaluationResolver,
  params: [{ name: 'slotIDs', type: () => [ID] }],
});

export const getSlotsWithoutKonsens = registerQuery({
  operationName: 'getSlotsWithoutKonsens',
  type: () => [InspectorOverviewLine],
  resolve: () => getSlotsWithoutKonsensResolver(),
  params: [],
});

export const getSlotForRating = registerQuery({
  operationName: 'getSlotForRating',
  type: () => Slot,
  resolve: getSlotForRatingResolver,
  params: [{ name: 'ratingID', type: () => String }],
});

export const getNextSlotForEvaluation = registerQuery({
  operationName: 'getNextSlotForEvaluation',
  type: () => Slot,
  resolve: getNextSlotForEvaluationResolver,
  params: [],
});
